import { DvSnapshotField } from './snapshot-field.entity';
import { Expose } from 'class-transformer';
export class DvSnapshotGroup {
  @Expose()
  groupName?: string; //user input "My situation", "Personal Info"
  @Expose()
  groupCode?: string; //stepper name / cross reference "mySituation", "personalInformation"
  @Expose()
  groupDescription: string; //section description displayed below header
  @Expose()
  splitAfter?: number; //number of items before column split on display dump
  @Expose()
  dataFields?: DvSnapshotField[];
}
